import React from 'react'
import ModalComponent from 'components/ModalComponent'
import styles from './PublicQuestions.module.scss'
import {Cancel, ObjectSVG} from 'assets/svgs'

interface DetailModalProps {
  show: boolean
  onClose: () => void
  title: string
  content: string
}

const DetailModal: React.FC<DetailModalProps> = ({ show, onClose, title, content }) => {
  return (
    <ModalComponent show={show} handleClose={onClose}>
      <div className={styles.detailModal}>
        <div className={styles.detailModalContent}>
          <div className={styles.detailModalHeading}>
            <Cancel className={styles.cancel} onClick={onClose} />
            <div className={styles.infoContainer}>
              <ObjectSVG className={styles.help} />
            </div>
          </div>
          <h1>{title}</h1>
          <p>{content}</p>
        </div>
      </div>
    </ModalComponent>
  )
}

export default DetailModal